import {
  announceCartFeedback,
  getCartErrorMessage,
  getCartSuccessMessage,
} from './cart-feedback.js';


const cartElement = 's-cart';

function configureStandardActions(actions) {
  actions.openCart.configure({
    async handler(defaultHandler) {
      /** @type {HTMLDialogElement | null} */
      const dialog = document.getElementById('cart-drawer');
      if (dialog instanceof HTMLDialogElement) {
        if (!dialog.open) dialog.showModal();
      } else {
        await defaultHandler();
      }
    },
  });

  actions.updateCart.configure({
    // updateCart events bubble from <s-cart> so cart-feedback / s-cart
    // listeners pick them up. Falls back to document if <s-cart> isn't
    // mounted (e.g. cart page itself before s-cart upgrades).
    eventTarget: () => document.querySelector(cartElement) ?? document,
    async handler(defaultHandler, payload, options) {
      try {
        const result = await defaultHandler();

        if (!result?.userErrors?.length && options?.event?.context === 'product') {
          actions.openCart();
        }

        await customElements.whenDefined(cartElement);
        await customElements.get(cartElement)?.refreshMountedCarts?.({ signal: options?.signal });

        const message = result?.userErrors?.[0]?.message || getCartSuccessMessage(payload?.lines);
        await announceCartFeedback(message, { toast: Boolean(result?.userErrors?.length) });

        return result;
      } catch (error) {
        if (!options?.signal?.aborted) {
          await announceCartFeedback(getCartErrorMessage(error), { toast: true });
        }

        throw error;
      }
    },
  });
}

if (window.Shopify?.actions) {
  configureStandardActions(window.Shopify.actions);
} else {
  document.addEventListener('DOMContentLoaded', () => window.Shopify?.actions && configureStandardActions(window.Shopify.actions), { once: true }); // spec-audit-disable-line no-domcontentloaded
}
